import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import TaxiServices from "@/pages/TaxiServices";
import ServiceDetail from "@/pages/ServiceDetail";
import Fleet from "@/pages/Fleet";
import TourPackages from "@/pages/TourPackages";
import TourDetail from "@/pages/TourDetail";
import CityPage from "@/pages/CityPage";
import RoutePage from "@/pages/RoutePage";
import Contact from "@/pages/Contact";
import BookTaxi from "@/pages/BookTaxi";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import SitemapPage from "@/pages/SitemapPage";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import BookingsAdmin from "@/pages/admin/BookingsAdmin";
import CustomersAdmin from "@/pages/admin/CustomersAdmin";
import MessagesAdmin from "@/pages/admin/MessagesAdmin";
import VehiclesAdmin from "@/pages/admin/VehiclesAdmin";
import ServicesAdmin from "@/pages/admin/ServicesAdmin";
import PackagesAdmin from "@/pages/admin/PackagesAdmin";
import ReviewsAdmin from "@/pages/admin/ReviewsAdmin";
import BlogsAdmin from "@/pages/admin/BlogsAdmin";
import CitiesAdmin from "@/pages/admin/CitiesAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import PasswordAdmin from "@/pages/admin/PasswordAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/taxi-services" element={<TaxiServices />} />
                <Route path="/taxi-services/:slug" element={<ServiceDetail />} />
                <Route path="/fleet" element={<Fleet />} />
                <Route path="/tour-packages" element={<TourPackages />} />
                <Route path="/tour-packages/:slug" element={<TourDetail />} />
                <Route path="/jodhpur-taxi" element={<CityPage />} />
                <Route path="/jaipur-taxi" element={<CityPage />} />
                <Route path="/udaipur-taxi" element={<CityPage />} />
                <Route path="/jaisalmer-taxi" element={<CityPage />} />
                <Route path="/routes/:slug" element={<RoutePage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/book-taxi" element={<BookTaxi />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-conditions" element={<Terms />} />
                <Route path="/sitemap" element={<SitemapPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="bookings" element={<BookingsAdmin />} />
                <Route path="customers" element={<CustomersAdmin />} />
                <Route path="messages" element={<MessagesAdmin />} />
                <Route path="vehicles" element={<VehiclesAdmin />} />
                <Route path="services" element={<ServicesAdmin />} />
                <Route path="packages" element={<PackagesAdmin />} />
                <Route path="reviews" element={<ReviewsAdmin />} />
                <Route path="blogs" element={<BlogsAdmin />} />
                <Route path="cities" element={<CitiesAdmin />} />
                <Route path="settings" element={<SettingsAdmin />} />
                <Route path="password" element={<PasswordAdmin />} />
              </Route>
            </Routes>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
